/*!
 * Copyright (c) 2015-2017 Cisco Systems, Inc. See LICENSE file.
 */

import '@ciscospark/internal-plugin-user';
import '@ciscospark/internal-plugin-wdm';

import {registerInternalPlugin} from '@ciscospark/spark-core';
import Avatar from './avatar';
import config from './config';

registerInternalPlugin('avatar', Avatar, {
  config
});

export {default} from './avatar';
